<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click="handleSaveSubmit">{{$t('保存更改')}}</el-button>
      <el-button @click.native="$refs.treeTable.handleChangeExpandState()">{{ expandState ? $t('收起') : $t('展开') }}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('标题')">
        <el-input :placeholder="$t('标题')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <tree-table :column-list="columnList"
                  :data.sync="tableData"
                  disabledExpandByDefault
                  :expand.sync="expandState"
                  :height="height"
                  ref="treeTable"
                  :row-template="rowTemplate">
        <template #operate="{row}">
          <div class="fb-link-flex">
            <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            <el-link type="primary" :underline="false" @click="$router.push('detail?code=' + row.code)">{{$t('查看')}}</el-link>
            <template  v-if="!row.sub.length">
              <el-link type="primary" :underline="false" @click="$router.push('edit?code=' + row.code)">{{$t('编辑')}}</el-link>
            </template>
          </div>
        </template>
      </tree-table>
    </template>
  </ankh-list>
</template>

<script>
import {request} from "@/config/request";
import {handleBuildTreeData, handleDeleteTip, handleDeleteTreeNode} from "@/utils/levelUtils";
import AnkhList from "@/components/list/AnkhList.vue";
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {resetEmpty} from "@/utils/common";

export default {
  name: "FAQList",
  components: {TreeTable, AnkhList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],

      expandState: false,

      columnList: [
        {label: "标题", prop: "name", type: "input", fixed: 'left'},
        {label: "移动", prop: "", type: "more"},
        {label: "默认展开", prop: "expand", type: "switch"},
        {label: "创建时间", prop: "createTimeStr"},
        {label: "操作", prop: "operate"},
      ],

      // 新增row 需要的字段数据
      rowTemplate: {
        name: "",
        expand: "yes",
        photo: "",
        createTimeStr: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
      }

    }
  },
  methods: {
    reset() {
      resetEmpty(this.searchForm)
    },
    // 保存
    async handleSaveSubmit() {
      try {
        let params = this.handleBuildParams(this.tableData);
        await request(this.$api.questionSort.save, params, {isJson: true});
        this.$message.success(this.$t('保存成功'));
        await this.handleSearch();
      }catch(e) {
        console.log(e);
      }
    },

    // 处理数据
    handleBuildParams(list) {
      return list.map((item, index) => {
        let sub = [];
        if(item.sub.length) {
          sub = this.handleBuildParams(item.sub);
        }
        return {
          name: item.name,
          code: item.isNewAdd ?  null : item.code,
          sort: index + 1,
          expand: item.expand,
          sub,
        }
      })
    },

    async handleDelete(row) {
      try {
        await handleDeleteTip();
        if (!row.isNewAdd) {
          await request(this.$api.questionSort.delete, {code: row.code});
        }
        this.tableData = handleDeleteTreeNode([row.code], this.tableData);
        this.$message.success(this.$t('操作成功'));
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      const selected = this.$refs.treeTable.handleGetSelected();
      if (!selected.length) {
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      }
      try {
        await handleDeleteTip();
        let codes = selected.filter(f => !f.isNewAdd).map(item => item.code);
        if (codes.length) {
          await request(
              this.$api.questionSort.batchDelete,
              codes,
              {isJson: true},
          );
        }
        const delCodes = selected.map(item => item.code);
        this.$message.success(this.$t('操作成功'));
        this.tableData = handleDeleteTreeNode(delCodes, this.tableData);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.questionSort.list, params);
        this.tableData = handleBuildTreeData(res.questionSorts, item => {
          item.createTimeStr = this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss");
          return item;
        });
      } catch (e) {
        console.error(e);
      }
    }
  },
  mounted() {
    this.handleSearch();
  }
}
</script>

<style scoped>

/deep/ .cell {
  display: flex;
  align-items: center;
}

</style>
